import LightbulbIcon from "@mui/icons-material/Lightbulb";
import { Box, Grid, Typography } from "@mui/material";
import React from "react";

const teamSize = [
  {
    id: 1,
    title: "It's just me",
  },
  {
    id: 2,
    title: "2-5 people",
  },
  {
    id: 3,
    title: "6-10 people",
  },
  {
    id: 4,
    title: "11+ people",
  },
];

const StepThree = ({ selectItem, setSelectItem }) => {
  return (
    <Box>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} sm={8} md={4.5}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              marginBottom: "15px",
              color: "rgb(178 181 178)",
            }}
          >
            Account Setup
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "30px", marginBottom: "15px" }}
          >
            What's your team size?
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: "15px",
              marginBottom: "15px",
              color: "rgb(178 181 178)",
            }}
          >
            This will help us setup your calendar correctly. Don't worry, this
            doesn't change the price - you can have unlimited team members for
            free on Loba!
          </Typography>
          {teamSize.map((itemmm) => {
            return (
              <Box
                sx={{
                  padding: "20px 25px",
                  border: `2px solid ${
                    selectItem?.id == itemmm?.id ? "orange" : "rgb(206 212 212)"
                  }`,
                  borderRadius: "15px",
                  marginBottom: "15px",
                  cursor: "pointer",
                  background:
                    selectItem?.id == itemmm?.id ? "rgb(206 212 212)" : "none",
                }}
                onClick={() => setSelectItem(itemmm)}
              >
                <Typography sx={{}}>{itemmm.title}</Typography>
              </Box>
            );
          })}

          <Box
            sx={{
              padding: "20px 25px",
              borderRadius: "15px",
              marginBottom: "15px",
              cursor: "pointer",
              background: "rgb(191 201 217)",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <LightbulbIcon />
            <Typography sx={{ marginLeft: "10px" }}>
              We'll add 'Wendy' as an example employee so you can see how the
              system works. You can manage employees later once you're in!
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StepThree;
